"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _density = require("@site/pattern-library-utils/density");
var _index = _interopRequireDefault(require("../../../../elements/other/headline-lockup/index.js"));
var _text = _interopRequireDefault(require("@ux/text"));
/**
 * Local Imports
 */

const PriceContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PriceContainer",
  class: "pl-pljr0x6"
});
const FlagColumn = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FlagColumn",
  class: "pl-fik2zjf"
});

/**
 * HeadColumn Component.
 *
 * @param {Object} props React props
 * @param {String} props.planType Plan type name
 * @param {String} props.packageName Package name
 * @param {String} props.flagText Selected Column text
 * @returns {React.ReactElement} HeadColumn Component
 * @public
 */

function HeadColumn({
  planType,
  packageName,
  flagText
}) {
  return /*#__PURE__*/_react.default.createElement(PriceContainer, {
    hasFlag: false
  }, flagText && /*#__PURE__*/_react.default.createElement(FlagColumn, {
    "data-cy": "flag",
    hasFlag: true
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    text: flagText
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "plans"
  }, planType && /*#__PURE__*/_react.default.createElement(_index.default, {
    heading: planType,
    headlineTag: "h3",
    headlineSize: "h6",
    textAlign: "start",
    headingDataCy: "plan-type"
  }), packageName && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -2,
    text: packageName,
    "data-cy": "package-name"
  })));
}
var _default = exports.default = HeadColumn;
HeadColumn.propTypes = {
  planType: _propTypes.default.string,
  packageName: _propTypes.default.string,
  flagText: _propTypes.default.string
};